<h3>Games tagged "{{tagname}}"</h3>
<br>
<game-info *ngFor="let game of games" [game]="game"></game-info>